import { useReactiveVar } from '@apollo/client'
import { LockClosedIcon } from '@radix-ui/react-icons'
import { Flex } from '@radix-ui/themes'
import { isPrivyReadyVar } from 'features/auth-privy/store'
import { DataTestIDs } from 'shared/constants'
import { shortenAddress } from 'shared/utils/shorten-address'
import { exportPrivyKey } from '../utils/wallet-actions'
import styles from '../neon-wallets.module.scss'

interface Props {
  /** The embedded wallet created by Privy; the only key Privy can export. */
  address: string
}

/** Privy only (FE-304): the embedded wallet's key leaves through Privy's own modal. */
export const PrivyExportSection: React.FC<Props> = ({ address }) => {
  const isPrivyReady = useReactiveVar(isPrivyReadyVar)

  return (
    <Flex
      align='center'
      gap='3'
      className={styles.exportRow}
    >
      <LockClosedIcon className={styles.exportIcon} />
      <span className={styles.sectionText}>
        The wallet {shortenAddress(address)} was created by Privy when you
        signed up. Its private key can be exported in Privy&apos;s own window;
        it never reaches XYRO.
      </span>
      <button
        type='button'
        className={styles.secondaryButton}
        data-size='sm'
        disabled={!isPrivyReady}
        onClick={() => void exportPrivyKey()}
        data-testid={DataTestIDs.buttonPrivyWalletExport}
      >
        Export key
      </button>
    </Flex>
  )
}
